<template src="../../../public/HODORegulationWeb/index.html"></template>

<script>
export default {
  name: 'RegulationWebsite',

  data () {
    return {}
  }
}
</script>

<style lang="css" scoped src="../../../public/HODORegulationWeb/quyche_files/Site.css"></style>
